import React from "react"
import PropTypes from "prop-types"
import ScrollToPosition from '../utils/ScrollToPosition'
import Icon from './Icon'

class StandardModal extends React.Component {
  constructor(props) {
    super(props)

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleBackdropClick = this.handleBackdropClick.bind(this)
    this.handleModalClick = this.handleModalClick.bind(this)
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown)
    this.previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
    document.body.style.overflow = this.previousOverflow
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.props.onClose()
    }
  }

  handleBackdropClick() {
    this.props.onClose()
  }

  handleModalClick(event) {
    event.stopPropagation()
  }

  modalClassName() {
    const classes = ['standardModal']

    if (this.props.modalClass) {
      classes.push(this.props.modalClass)
    }

    if (this.props.size === 'wide') {
      classes.push('standardModal--wide')
    } else if (this.props.size === 'full') {
      classes.push('standardModal--full')
    }

    if (this.props.showCloseButton) {
      classes.push('standardModal--withClose')
    }

    return classes.join(' ')
  }

  overlayClassName() {
    const classes = ['standardModalOverlay']

    if (this.props.overlayClass) {
      classes.push(this.props.overlayClass)
    }

    return classes.join(' ')
  }

  render() {
    const { children, onClose, showCloseButton, title } = this.props

    return(
      <div
        className={this.overlayClassName()}
        onClick={this.handleBackdropClick}
        role="presentation"
      >
        <ScrollToPosition />
        <div
          className={this.modalClassName()}
          onClick={this.handleModalClick}
          role="dialog"
          aria-modal="true"
          aria-label={title}
        >
          {showCloseButton &&
            <button
              type="button"
              className="standardModal__close"
              onClick={onClose}
              aria-label="Close"
            >
              <Icon name="times" size={18} color="currentColor" />
            </button>
          }
          <div className="standardModal__content">
            {children}
          </div>
        </div>
      </div>
    )
  }
}

StandardModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
  showCloseButton: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'wide', 'full']),
  modalClass: PropTypes.string,
  overlayClass: PropTypes.string,
}

StandardModal.defaultProps = {
  showCloseButton: true,
  size: 'default',
}

export default StandardModal;
